import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-online-course-header',
  templateUrl: './online-course-header.component.html',
  styleUrls: ['./online-course-header.component.css']
})
export class OnlineCourseHeaderComponent implements OnInit {

  is_country_fp = false;
  constructor(private router: Router) { }
  ngOnInit() {
      var currentUserId = JSON.parse(localStorage.getItem('currentUserId'));
      if(currentUserId)
      this.is_country_fp = currentUserId.country_focal_point;
  }
  homeButtonClick(){
  	this.router.navigateByUrl('/home')
  }
  introBtnClick(){
    this.router.navigateByUrl('/introduction/intro-home')
  }
  compBtnClick(){
      this.router.navigateByUrl('/sdg/sdg-home')
      $(".header_active").removeClass("header_active")
      $(".home-click").addClass("header_active")
  }
  viewSummaryBtnClick(){
      this.router.navigateByUrl('/view-summary')
  }
  logoutClick(){
    localStorage.setItem('editmode', '0');
    this.router.navigateByUrl('/login')
  }
  profileClick(){
    this.router.navigateByUrl('/profile')
  }
  profileIconClick(){
    $('.dropdown-content').slideToggle(400, 'swing');
  }
  register1Click(){
      this.router.navigateByUrl('/register')
  }
  feedbackClick(){
      this.router.navigateByUrl('/feedback')
  }
  manageTeamClick(){
    this.router.navigateByUrl('/manage-team')
  }

}



// WEBPACK FOOTER //
// ./src/app/online-course-header/online-course-header.component.ts